<template>
  <div id="app">
    <Header :select-index="HeaderIndex" v-if="showHeader" ref="Header" />
      <transition name="appList">
        <router-view :ref="childRouteName" />
      </transition>
    <Footer :no-bg="false" v-if="showHeader" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showHeader: false,
      HeaderIndex: undefined,
      childRouteName: '',
      notifyPromise: Promise.resolve()
    }
  },
  watch:{
    $route(to,from){
      let nowPath = to.path;
      let fromPath = from.path
      if(nowPath !== fromPath){
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }
      this.childRouteName = nowPath;
      if(nowPath === '/'){
        this.showHeader = false;
      }else{
        this.showHeader = true;
      }
      if(nowPath.search('/WholeSearch') > -1){
        this.HeaderIndex = 0;
      }else if(nowPath.search('/testOrg') > -1){
        this.HeaderIndex = 4;
      }else if(nowPath.search('/hotTest') > -1){
        this.HeaderIndex = 2;
      }else if(nowPath.search('/freeTest') > -1){
        this.HeaderIndex = 3;
      }else if(nowPath.search('/test') > -1){
        this.HeaderIndex = 1;
      }else{
        this.HeaderIndex = undefined;
      }
    }
  },
  methods: {
    getHeaderMsg(){
      this.$refs['Header'].messageDrawer = true;
    },
    updateLoginState(){
      console.log('登录成功！')
      this.$refs['Header'].isLogined = true;
    }
  }
}
</script>

<style>
  #nprogress .bar{background: #f09005; height: 4px;}
  #app{font-family:'Avenir',Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale;color:#333;}
  *{margin:0;padding:0;}
  body{background: #eff3f5}
  a.blk{text-decoration: none;display: block;}
  ul.def{list-style: none;}
  .def-content {min-width: 1100px;max-width: 1280px;margin:0 auto;}

/*  !*分页 start*! */
  .pagination-warp{padding-top:50px;display:flex;justify-content:space-evenly;}

  .linkA{
    color: #606266;
    text-decoration: none;
  }
  .linkA:hover {
    color: #00BCA1;
  }

  .appList-enter{
    opacity: 0;
    transform: translateX(100%);
  }
  .appList-leave-to{
    opacity: 0;
    transform: translateX(-100%);
    position: absolute;
  }
  .appList-enter-active,.appList-leave-active{
    transition: all 0.5s ease;
  }

  /*首页轮播重置样式*/
  .home-banner .el-carousel__mask{
    background: none;
  }

  .el-tree-node__label{
    font-size: 16px;
  }

  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue